import { useTranslation } from "@repo/core";

interface MissingTurnoverProps {
  className?: string;
}

export const MissingTurnover = ({ className = "" }: MissingTurnoverProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        {t("turnover.title")}
      </h2>
      <hr className="border-gray-200 mb-6" />
      <div className="flex items-center justify-center h-96">
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-2">📊</div>
          <p className="text-lg font-medium">{t("turnover.notAvailable")}</p>
          <p className="text-sm mt-2">{t("turnover.unableToLoad")}</p>
        </div>
      </div>
    </div>
  );
};

export default MissingTurnover;
